import { Routes, Route, Navigate } from "react-router-dom";
import DashboardLayout from "../layouts/DashboardLayout";
import RequireAuth from "../shared/components/RequireAuth";
import RequirePermission from "../shared/components/RequirePermission";
import { isModuleHidden } from "../config/hiddenModules";

// Pages
import Home from "../pages/Home";
import Login from "../pages/Login";
import UniversalBenchmark from "../pages/UniversalBenchmark";
import RateCardConverter from "../pages/RateCardConverter";
import DataCleaning from "../pages/DataCleaning";
import UniversalBenchmarkCalculator from "../pages/UniversalBenchmarkCalculator";
import TicketPerformance from "../pages/TicketPerformance";
import MachshipTemplate from "../pages/MachshipTemplate";
import KPIPerformance from "../pages/KPIPerformance";
import MachshipTemplateAutomatic from "../pages/MachshipTemplateAutomatic";
import CustomerRateGenerator from "../pages/CustomerRateGenerator";
import PricingPowerpoint from "../pages/PricingPowerpoint";
import CustomerCareKPIPerformance from "../pages/CustomerCareKPIPerformance";
import ReportingHub from "../pages/ReportingHub";
import DifotTools from "../pages/DifotTools";
import QbrDashboard from "../pages/QbrDashboard";
import DeliveryRulesEngine from "../pages/DeliveryRulesEngine";
import CarrierDifotIntegration from "../pages/CarrierDifotIntegration";
import PerformanceReport from "../pages/PerformanceReport";
import CustomerHealth from "../pages/CustomerHealth";
import DifotReport from "../pages/DifotReport";
import JupiterPortal from "../pages/JupiterPortal";
import CarrierServiceMap from "../pages/CarrierServiceMap";
import NotFound from "../pages/NotFound";

const authRoutes = [{ path: "login", element: <Login /> }];

// Protected dashboard routes config
const dashboardRoutes = [
  { path: "", element: <Home /> },
  { path: "rateCardConverter", element: <RateCardConverter />, moduleKey: "ratecard", action: "read" },
  { path: "universalBenchmark", element: <UniversalBenchmark />, moduleKey: "benchmark", action: "read" },
  { path: "dataCleaning", element: <DataCleaning />, moduleKey: "data-cleaning", action: "read" },
  {
    path: "universalBenchmarkCalculator",
    element: <UniversalBenchmarkCalculator />, moduleKey: "benchmark", action: "read"
  },
  { path: "ticketPerformance", element: <TicketPerformance />, moduleKey: "ticket-performance", action: "read" },
  { path: "machshipTemplate", element: <MachshipTemplate />, moduleKey: "machship", action: "read" },
  {
    path: "machshipTemplateAutomatic",
    element: <MachshipTemplateAutomatic />, moduleKey: "machship", action: "read"
  },
  { path: "kpiPerformance", element: <KPIPerformance />, moduleKey: "kpi-performance", action: "read" },
  {
    path: "customerRatecardGenerator",
    element: <CustomerRateGenerator />, moduleKey: "ratecard", action: "write"
  },
  { path: "pricingPowerpoint", element: <PricingPowerpoint />, moduleKey: "pricing", action: "read" },
  {
    path: "customerCareKPIPerformance",
    element: <CustomerCareKPIPerformance />, moduleKey: "customer-care-kpi", action: "read"
  },
  { path: "reportingHub", element: <ReportingHub />, moduleKey: "reporting", action: "read" },
  { path: "difotTools", element: <DifotTools />, moduleKey: "difot", action: "read" },
  { path: "qbrDashboard", element: <QbrDashboard />, moduleKey: "difot", action: "read" },
  {
    path: "carrierDifotIntegration",
    element: <CarrierDifotIntegration />,
    moduleKey: "difot",
    action: "read",
  },
  { path: "deliveryRulesEngine", element: <DeliveryRulesEngine />, moduleKey: "delivery-rules", action: "read" },
  { path: "performanceReport", element: <PerformanceReport />, moduleKey: "performance-report", action: "read" },
  { path: "customerHealth", element: <CustomerHealth />, moduleKey: "customer-health", action: "read" },
  { path: "difotReport", element: <DifotReport />, moduleKey: "difot-report", action: "read" },
  { path: "jupiterPortal", element: <JupiterPortal />, moduleKey: "jupiter-portal", action: "read" },
  { path: "carrierServiceMap", element: <CarrierServiceMap />, moduleKey: "difot", action: "read" },
];

const renderRoutes = (routes) =>
  routes
    .filter(({ moduleKey }) => !isModuleHidden(moduleKey))
    .map(({ path, element, moduleKey, action }) => {
      if (moduleKey) {
        return (
          <Route
            key={path || "home"}
            path={path}
            element={<RequirePermission moduleKey={moduleKey} action={action} />}
          >
            <Route index element={element} />
          </Route>
        );
      }
      return <Route key={path || "home"} path={path} element={element} />;
    });

const AppRoutes = () => {
  return (
    <Routes>
      {/* Auth Routes */}
      <Route path="/auth" element={<RequireAuth isAuthPage />}>
        {renderRoutes(authRoutes)}
        <Route path="*" element={<NotFound />} />
      </Route>

      {/* Protected Routes */}
      <Route element={<RequireAuth />}>
        <Route path="/" element={<DashboardLayout />}>
          <Route path="kPIPerformance" element={<Navigate to="/kpiPerformance" replace />} />
          {renderRoutes(dashboardRoutes)}
          <Route path="*" element={<NotFound />} />
        </Route>
      </Route>
    </Routes>
  );
};

export default AppRoutes;
